import React from 'react';
import './style.scss';

export const ConfidenceProgressBar = ({ title, percent }) => (
  <div className="confidence_progress_bar">
    <div className="confidence_progress_bar_wrapper">
      <div className="confidence_progress_bar_percent" style={{ height: `${percent}%` }} />
    </div>
    <div className="confidence_progress_bar_name">
      <span>{percent === 0 ? '--' : percent} %</span>
      <p>{title}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ConfidenceProgressBar/index.js